import { API_ENDPOINT } from '../api-endpoints';

export const CJX_API_ENDPOINT = {
  ...API_ENDPOINT,
  promotions: {
    ...API_ENDPOINT.promotions,
    exportStore: '/V2/{promotionCode}',
    cancel: '/V2/cancel',
    delete: '/V2/delete'
  },
  exportReport: {
    ...API_ENDPOINT.exportReport,
    exportAssortment: '/assortment/export',
    exportAssortmentConfidential: '/assortment_confidential/export',
    exportAssortmentLocation: '/product_by_location/export',
    movingAverage: '/moving-average/export',
    exportByStore: '/store_assortment/export',
    stockCardExport: '/stock-card/export',
    stores: '/stores/export',
    storeConfidential: '/stores/confidential/export',
    storeOrderSchedule: '/store-order-schedule/export',
    supplierCouponTransaction: '/supplier-coupon-transaction/export',
    supplierCouponIssueTransaction: '/supplier-coupon-issue-transaction/export',
    stockByProductExport: '/stock-by-product/export',
    stockByLocationExport: '/stock-by-location/export',
    stockAdjustment: '/stocks/adjust/export',
    memberProfile: '/member-profile/export',
    pointActivity: '/point-activity/export',
    claimExport: '/claim-request/export',
    edcPaymentTransaction: '/edc-payment-transaction/export'
  }
};
